import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hh7y84r3b: FaireProductEntity = {
  token: "p_8hh7y84r3b",
  type: "product",
  name: "14K Gold Dipped CZ Sparkle Starburst Cluster Stud Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/787fa47f3bde4e2aca0f2ddd2d6ec63991f1d0eaf1091a4011063d1bef507f76.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/502dc378c9e7098c9cd6301099f7a2ef7165ed8edfb59aaff61db32007ce51e2.jpeg",
    "https://cdn.faire.com/fastly/567b54dee9d6343348c6df1f24d5c7088e37ce68af84bc1faffdbedd0307a98d.jpeg",
  ],
  priceDollars: 6.49,
  description:
    'Size : 0.5" X 0.5"\r\nPost Back\r\nAdd radiant sparkle to your jewelry collection with these crystal starburst stud earrings featuring a delicate burst design and shimmering stones. A stylish accessory perfect for everyday wear, parties, and special occasions.\nBrass\nCZ Cubic Zirconia \nGold Dipped\nHypoallergenic\nLead and Nickel Compliant\nMade In Korea\n',
  tags: [],
  msrpDollars: 12.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:55.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
